import { render, staticRenderFns } from "./QuickSale.vue?vue&type=template&id=32ce50d8&scoped=true&"
import script from "./QuickSale.vue?vue&type=script&lang=js&"
export * from "./QuickSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce50d8",
  null
  
)

component.options.__file = "QuickSale.vue"
export default component.exports